'use strict';

var ScrollTo = {
  go: function (event) {
    event && event.preventDefault();

    var scrollTo = $(this).attr('data-to');
    var navHeight = 0;
    var execution = false;

    if (!scrollTo) return;

    if ($('body').hasClass('page-store')) {
      navHeight = Number($('.nav-landing').height());
    }

    (function animateScroll() {
      $('html, body').animate(
        {
          scrollTop: Number($("[data-id='" + scrollTo + "']").offset().top || 0) - navHeight
        },
        500,
        'swing',
        function () {
          window.location.hash = scrollTo.replace(/\//, '');
          if (!execution) {
            execution = true;
            animateScroll();
          }
        }
      );
    })();
  }
};

var forceGoToHash = function () {
  if (!window.location.hash || /\/(minha-conta#|rastreio)/.test(window.location.href)) return;
  var dataTo = window.location.hash.substr(1).replace(/\?.*/, '');
  var $archor = $('[data-to="' + dataTo + '"]');
  if ($archor.length) $archor.click();
};

$('.js-scroll-to').on('click', ScrollTo.go);

forceGoToHash();
